import { render, staticRenderFns } from "./xiuxianDetail.vue?vue&type=template&id=259d8ce1&scoped=true&"
import script from "./xiuxianDetail.vue?vue&type=script&lang=js&"
export * from "./xiuxianDetail.vue?vue&type=script&lang=js&"
import style0 from "./xiuxianDetail.vue?vue&type=style&index=0&id=259d8ce1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d8ce1",
  null
  
)

export default component.exports